module.exports = __webpack_public_path__ + "static/gnome_male-0981b82ea4a5f603fc9ce83506e13d70.jpg";